import { getDefaultPlayerFields as coreGetDefaultPlayerFields } from 'js/hooks/usePlayerFields/helpers';

export * from 'js/hooks/usePlayerFields/helpers';

export const getDefaultPlayerFields = () => {
    const fieldListFromCore = coreGetDefaultPlayerFields();

    // accountBusinessPhase (string)
    fieldListFromCore.push(106);
    // homeVenue
    fieldListFromCore.push(151);

    return fieldListFromCore;
};
